module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/textbooks-35b5ece3eea9b00a460f2918864c8279.svg";